// Component 1: Setup.jsx - Main Container
import React, { useContext, useState } from 'react'
import css from "./style.module.css"
import SetupTabPanel from './SetupTabPanel';
import ManageFields from './ManageFields';
import { useNavigate } from 'react-router-dom';
import { MarktingContext } from '../../Context/MarktingContext';
import BackSection from '../Services/BackSection';

export default function Setup() {
  const [activeTab, setActiveTab] = useState("Document Type");
  const [key, setKey] = useState("types");
  const [editIndex, setEditIndex] = useState(null);
  const navigate = useNavigate();
  const { userTeam } = useContext(MarktingContext);

  return (
    <section>
      <BackSection pageName="Setup Dashboard" to={"/marketingcompliance"} />
      <div className="row">
          <div className="col-12">
            {/* Header - Responsive Layout */}
            <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-end justify-content-end mb-3 gap-3">
              {/* <h4 className="title mb-0">Setup Dashboard</h4> */}
              {/* Button Group - Stack on mobile, inline on desktop */}
              <div className="d-flex flex-column flex-sm-row gap-2">
                <button
                  className="btn btnCustom d-flex justify-content-center align-items-center rounded-5 flex-shrink-0"
                  onClick={() => navigate("/setup/archived")}
                >
                  <span className="d-none d-sm-inline">View Archived Documents</span>
                  <span className="d-sm-none">Archived</span>
                </button>

                {(userTeam === "superAdmin" || userTeam === "admin") && (
                  <button
                    className="btn btnAdmin d-flex justify-content-center align-items-center rounded-5 flex-shrink-0"
                    onClick={() => navigate("/adminpanel")}
                  >
                    <span className="btnAdmin__icon me-1">⚙️</span>
                    <span className="d-none d-sm-inline">Admin Panel</span>
                    <span className="d-sm-none">Admin</span>
                  </button>
                )}
              </div>
            </div>

            {/* Subtitle */}
            <p className="mb-3 fs-4 fs-md-3 fw-light">Manage Fields</p>

            {/* Tabs - Responsive Navigation */}
            <div className={`${css.tabsWrapper} mb-4`}>
              <ul className={`${css.tabsContainer} nav nav-pills flex-column flex-sm-row`}>
                <SetupTabPanel
                  tabName="Document Type"
                  objKey="types"
                  setKey={setKey}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setEditIndex={setEditIndex}
                />
                <SetupTabPanel
                  tabName="Media Channel"
                  objKey="channels"
                  setKey={setKey}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setEditIndex={setEditIndex}
                />
                <SetupTabPanel
                  tabName="Target Geography"
                  objKey="geographies"
                  setKey={setKey}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setEditIndex={setEditIndex}
                />
                <SetupTabPanel
                  tabName="Priority Level"
                  objKey="priorities"
                  setKey={setKey}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setEditIndex={setEditIndex}
                />
              </ul>
            </div>

            {/* Content Area */}
            <ManageFields objKey={key} setEditIndex={setEditIndex} editIndex={editIndex} />
          </div>
        </div>
    </section>
  )
}
